import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {getServiceNoun} from './helpers';
import {MeetingImage} from './meeting-image';

import styles from './empty-state.module.css';

type Props = {
    setIsOnboardingModalOpen: (isOnboardingModalOpen: boolean) => void;
    serviceType: ExternalServiceType;
    isLoading: boolean;
};

export function EmptyState(props: Props) {
    const serviceNoun = getServiceNoun(props.serviceType);

    if (props.isLoading) {
        return null;
    }

    return (
        <div className={styles['empty-state-container']}>
            <EmptyStateLarge
                title={`Experience the convenience of ${serviceNoun} meetings in Nutshell`}
                subtitle='Connect your account to get started'
                detailTextBullets={[
                    `Gain valuable insights with AI-generated summaries for all your recorded ${serviceNoun} meetings.`,
                    'Seamlessly track meeting history with automatic timeline entries.',
                    'Access recordings and read meeting transcriptions, all within Nutshell.',
                ]}
                cta={
                    <Button
                        variant='primary'
                        size='big'
                        onClick={() => props.setIsOnboardingModalOpen(true)}
                    >
                        Connect to {serviceNoun}
                    </Button>
                }
                icon={<MeetingImage width={280} serviceType={props.serviceType} />}
            />
        </div>
    );
}
